import { Jwt } from '@thingslog/repositories';
import JwtValidator from './JwtValidator';

export default class RedirectHelper {
  private jwtValidator: JwtValidator;

  public constructor(user?: Jwt | null) {
    this.jwtValidator = new JwtValidator(user);
  }

  // #region public methods
  public shouldRedirectToPortal = (): boolean => {
    const decodedToken = this.jwtValidator.decodedToken;
    if (decodedToken) {
      return decodedToken.isDashboardEnabled;
    }

    return false;
  };

  public redirectToPortal = (): void => {
    window.location.href = `${location.protocol}//${location.host}/portal`;
  };
  // #endregion
}
